module.exports = function () {
    switch (process.env.NODE_ENV) {
        case 'staging':
            return new staging;
        case 'production':
            return new production;
        default:
            return new development;
    }
}

class baseConfiguration {
    Region = "us-east-1";
    AuthMode = "API_KEY";
    ClientDatabasePrefix = "opendata-directory_API_KEY"
}

class development extends baseConfiguration {
    ApiUrl = "https://6hxmptfugngvhpa45j47qyanfm.appsync-api.us-east-1.amazonaws.com/graphql";
    ApiKey = "da2-ynmwgdfbk5ezrn6srj26hndwwq";
}

class staging extends baseConfiguration {
    ApiUrl = "https://b5unihz63fd5pjrqm5rs5prb7i.appsync-api.us-east-1.amazonaws.com/graphql";
    ApiKey = "da2-uwknju4fczd7le5pxsw4rddc2m";
}

class production extends baseConfiguration {
    ApiUrl = "https://6hxmptfugngvhpa45j47qyanfm.appsync-api.us-east-1.amazonaws.com/graphql";
    ApiKey = "da2-ynmwgdfbk5ezrn6srj26hndwwq";
}